
  import { mapGetters } from 'vuex';

  export default {
    middleware: ['media/videos', 'breadcrumbs', 'jumbotron', 'meta-tags'],
    meta: {
      breadcrumbs: [['i18n/home', '/'], 'i18n/videos']
    },
    computed: {
      ...mapGetters('blog', { explainer: 'getArticle', videos: 'getList' }),
      category () {
        return this.$route.params.category;
      }
    }
  };
